<template>
  <!--班组记账  添加和编辑工友  -->
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="edittype ? '新增工友' : '编辑工友'"
    :visible.sync="showEdit"
    left
    width="600px"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <div>
        <el-form-item label="工友姓名" prop="name">
          <el-input
            maxlength="10"
            v-model="form.name"
            placeholder="请输入工友姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="工友电话" prop="phone">
          <el-input
            maxlength="11"
            v-model="form.phone"
            placeholder="请输入工友电话"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" style="text-align: center">
      <el-button class="cancelBtn" @click="showEdit = false">取消</el-button>
      <el-button type="primary" class="saveBtn" @click="save">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { api } from "@/api/apiRecord.js"

export default {
  name: "WorkerEditTeam",
  components: {},
  data() {
    return {
      showEdit: false,
      loading: false,
      form: {
        name: "",
        phone: ""
      },
      edittype: false, //是否是编辑状态
      rules: {
        name: [
          { required: true, message: "姓名不能为空" },
          {
            min: 1,
            max: 10,
            message: "姓名不能超过 10 个字符",
            trigger: "change"
          }
        ],
        phone: [
          {
            pattern:
              /^((13[0-9])|(14[0,5,6,7,9])|(15([0-3]|[5-9]))|(16([6,7]))|(17([1-3]|[5-8]))|(18[0-9])|(19[1,3,5,8,9]))\d{8}$/,
            message: "请输入正确的手机号码格式"
          }
        ]
      },
      type: this.$route.query.type ? this.$route.query.type : 1 //当前页面进入模式1.个人记工2.班组记工
    }
  },
  methods: {
    open(row = {}) {
      this.loading = false
      this.steps = 1
      this.showEdit = true
      let form = { ...row }
      let salaryStandardVo = { ...row.salaryStandardVo }
      delete salaryStandardVo.no
      delete form.salaryStandardVo
      form = { ...form, ...salaryStandardVo }
      !form.workOvertimeType && (form.workOvertimeType = "1")
      for (let i in this.form) {
        this.form[i] = form[i] ? form[i] : ""
      }
      this.form = { ...form }
      this.edittype = !form.name
      this.$nextTick(_ => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    async save() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.form.type = this.type //1:个人记工,2:个人记账,3:班组记工,4:班组记账
        this.loading = true
        let res = await api.settleWorkerAdd(this.form)
        if (res.data.code == 200) {
          this.showEdit = false
          this.$message.success(res.data.msg)
          this.$emit("editend", res.data.data)
        } else {
          this.$message.error(res.data.msg)
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 20px 20px 0;
}
/deep/.el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
/deep/ .el-dialog__footer {
  padding-top: 5px;
}
/deep/ .el-button + .el-button {
  margin-left: 15px;
}
/deep/ .el-form-item__content {
  height: 34px;
  line-height: 34px;
}
/deep/.el-form-item__label{
  line-height: 34px;
}
.el-button--primary {
  color: #fff;
  border-color: #b79255;
  background: #b79255;
  width: 58px;
  height: 34px;
  line-height: 34px;
  padding: 0;
  font-size: 14px;
  &:hover {
    color: #fff;
    border-color: #b79255;
    background: #b79255;
  }
  &:focus {
    color: #fff;
    border-color: #b79255;
    background: #b79255;
  }
}
.cancelBtn {
  color: #969696;
  border-color: #e4e7ed;
  background: #fff;
  width: 58px;
  height: 34px;
  line-height: 34px;
  padding: 0;
  font-size: 14px;
  &:hover {
    border-color: #e4e7ed;
    background: #fff;
    color: #969696;
  }
}
/deep/ .el-form-item {
  margin-bottom: 15px;
}
/deep/.el-table:before {
  height: 0;
}
/deep/.el-table--border:after,
.el-table--group:after {
  width: 0;
}
/deep/ .el-form-item__error {
  padding: 0;
}
</style>
